import { NoWrap } from "../../utils/helpers";

export const useUSSDSafeguards = () => {
  const tableColumns = () => [
    {
      id: "SafeGuard",
      header: "Safe Guard",
      filter: true,
    },
    {
      id: "Description",
      header: "Description",
    },

    {
      id: "Activity",
      header: "Activity",
    },
  ];

  const tableData = (data: any) =>
    data.map((item: any) => ({
      ...item,
      SafeGuard: <NoWrap>{item?.SafeGuard}</NoWrap>,
      Description: <NoWrap>{item?.Description}</NoWrap>,

      Activity: <NoWrap>{item?.Activity}</NoWrap>,
    })) || [];

  const tableTitle = "USSD Safeguards";

  return { tableData, tableColumns, tableTitle };
};
